export default {
  "pages.layouts.userLayout.title":
    "Ant Design 是西湖区最具影响力的 Web 设计规范",
  "pages.login.accountLogin.tab": "账户密码登录",
  "pages.login.accountLogin.errorMessage": "错误的用户名和密码",
  "pages.login.failure": "登录失败，请重试！",
  "pages.login.success": "登录成功！",
  "pages.login.username.placeholder": "用户名: admin or user",
  "pages.login.username.required": "用户名是必填项！",
  "pages.login.password.placeholder": "密码: ant.design",
  "pages.login.password.required": "密码是必填项！",
  "pages.login.phoneLogin.tab": "手机号登录",
  "pages.login.phoneLogin.errorMessage": "验证码错误",
  "pages.login.phoneNumber.placeholder": "请输入手机号！",
  "pages.login.phoneNumber.required": "手机号是必填项！",
  "pages.login.phoneNumber.invalid": "不合法的手机号！",
  "pages.login.captcha.placeholder": "请输入验证码！",
  "pages.login.captcha.required": "验证码是必填项！",
  "pages.login.phoneLogin.getVerificationCode": "获取验证码",
  "pages.getCaptchaSecondText": "秒后重新获取",
  "pages.login.rememberMe": "自动登录",
  "pages.login.forgotPassword": "忘记密码 ?",
  "pages.login.submit": "登录",
  "pages.login.loginWith": "其他登录方式 :",
  "pages.login.registerAccount": "注册账户",
  "pages.welcome.link": "欢迎使用",
  "pages.welcome.alertMessage": "更快更强的重型组件，已经发布。",
  "pages.404.subTitle": "抱歉，您访问的页面不存在。",
  "pages.404.buttonText": "返回首页",
  "pages.admin.subPage.title": " 这个页面只有 admin 权限才能查看",
  "pages.admin.subPage.alertMessage":
    "umi ui 现已发布，欢迎使用 npm run ui 启动体验。",
  "pages.searchTable.createForm.newRule": "新建规则",
  "pages.searchTable.updateForm.ruleConfig": "规则配置",
  "pages.searchTable.updateForm.basicConfig": "基本信息",
  "pages.searchTable.updateForm.ruleName.nameLabel": "规则名称",
  "pages.searchTable.updateForm.ruleName.nameRules": "请输入规则名称！",
  "pages.searchTable.updateForm.ruleDesc.descLabel": "规则描述",
  "pages.searchTable.updateForm.ruleDesc.descPlaceholder": "请输入至少五个字符",
  "pages.searchTable.updateForm.ruleDesc.descRules":
    "请输入至少五个字符的规则描述！",
  "pages.searchTable.updateForm.ruleProps.title": "配置规则属性",
  "pages.searchTable.updateForm.object": "监控对象",
  "pages.searchTable.updateForm.ruleProps.templateLabel": "规则模板",
  "pages.searchTable.updateForm.ruleProps.typeLabel": "规则类型",
  "pages.searchTable.updateForm.schedulingPeriod.title": "设定调度周期",
  "pages.searchTable.updateForm.schedulingPeriod.timeLabel": "开始时间",
  "pages.searchTable.updateForm.schedulingPeriod.timeRules": "请选择开始时间！",
  "pages.searchTable.titleDesc": "描述",
  "pages.searchTable.ruleName": "规则名称为必填项",
  "pages.searchTable.titleCallNo": "服务调用次数",
  "pages.searchTable.titleStatus": "状态",
  "pages.searchTable.nameStatus.default": "关闭",
  "pages.searchTable.nameStatus.running": "运行中",
  "pages.searchTable.nameStatus.online": "已上线",
  "pages.searchTable.nameStatus.abnormal": "异常",
  "pages.searchTable.titleUpdatedAt": "上次调度时间",
  "pages.searchTable.exception": "请输入异常原因！",
  "pages.searchTable.titleOption": "操作",
  "pages.searchTable.config": "配置",
  "pages.searchTable.subscribeAlert": "订阅警报",
  "pages.searchTable.title": "查询表格",
  "pages.searchTable.new": "新建",
  "pages.searchTable.chosen": "已选择",
  "pages.searchTable.item": "项",
  "pages.searchTable.totalServiceCalls": "服务调用次数总计",
  "pages.searchTable.tenThousand": "万",
  "pages.searchTable.batchDeletion": "批量删除",
  "pages.searchTable.batchApproval": "批量审批",

  // ========== 通用翻译 ==========
  // 按钮
  "button.search": "查询",
  "button.reset": "重置",
  "button.edit": "编辑",
  "button.delete": "删除",
  "button.remembered": "我已记住",
  "button.common.edit": "编辑",
  "button.common.delete": "删除",
  "button.common.more": "更多",
  "button.common.close": "关闭",

  // 消息提示
  "message.loading": "加载中",
  "message.noData": "暂无数据",
  "message.createSuccess": "创建成功",
  "message.createFailed": "创建失败",
  "message.updateSuccess": "修改成功",
  "message.updateFailed": "修改失败",
  "message.deleteSuccess": "删除成功",
  "message.deleteFailed": "删除失败",
  "message.password.safeguard": "请妥善保管密码，建议首次登录后修改密码。",

  // 状态
  "status.enabled": "启用",
  "status.disabled": "禁用",

  // 布尔值
  "boolean.yes": "是",
  "boolean.no": "否",
  "boolean.bound": "已绑定",
  "boolean.unbound": "未绑定",

  // 业务状态
  "business.open": "营业中",
  "business.closed": "休息",

  // 标签
  "label.initialPassword": "初始密码",
  "label.phone": "手机号",

  // 通用文字
  "common.unknown": "未知",

  // 表格通用列
  "table.common.status": "状态",
  "table.common.createdAt": "创建时间",
  "table.common.updatedAt": "更新时间",
  "table.common.action": "操作",
  "table.common.actions": "操作",
  "table.common.sortOrder": "排序",
  "table.common.brandName": "品牌名称",
  "table.common.storeName": "门店管理",
  "table.common.phone": "手机号",
  "table.common.email": "邮箱",
  "table.common.role": "角色",

  // 表单通用字段
  "form.common.status": "状态",
  "form.common.sortOrder": "排序",
  "form.common.phone": "手机号",
  "form.common.email": "邮箱",
  "form.common.note": "说明",
  "form.common.account": "账号",
  "form.common.password": "密码",

  // 通用验证消息
  "validation.status.required": "请选择状态",
  "validation.phone.required": "请输入手机号",
  "validation.phone.invalid": "请输入正确的手机号",
  "validation.email.invalid": "请输入正确的邮箱地址",
  "validation.common.phoneFormat": "请输入正确的手机号格式",
  "validation.common.statusRequired": "请选择状态",

  // 通用 placeholder
  "form.placeholder.input": "请输入",
  "form.placeholder.select": "请选择",
  "component.placeholder.select": "请选择",
  "component.placeholder.input": "请输入",
  "component.placeholder.noData": "暂无数据",
  "placeholder.phone": "请输入手机号",
  "placeholder.email": "请输入邮箱",
  "placeholder.common.startDate": "开始日期",
  "placeholder.common.endDate": "结束日期",

  // 分页
  "pagination.total": "共 {total} 条",

  // 筛选
  "filter.all": "全部",
  "filter.bound": "已绑定",
  "filter.unbound": "未绑定",

  // ========== 品牌管理 ==========
  "button.brand.create": "创建品牌",
  "error.brand.loadListFailed": "加载品牌列表失败",
  "error.brand.deleteFailed": "删除品牌失败",
  "error.brand.operationFailed": "品牌操作失败",
  "table.brand.brandName": "品牌名称",
  "table.brand.contactName": "联系人",
  "table.brand.contactPhone": "联系电话",
  "modal.brand.deleteTitle": "删除品牌",
  "modal.brand.deleteContent": "确定要删除该品牌吗？",
  "modal.brand.updateTitle": "修改品牌",
  "modal.brand.createTitle": "创建品牌",
  "message.brand.createSuccessDetail":
    "品牌创建成功！以下是超管账号信息，请妥善保管：",
  "message.brand.passwordGenerated": "已为超管账号生成密码,请妥善保管:",
  "message.brand.passwordWarning": "注意：密码仅此一次显示，请务必记录保存！",
  "form.brand.brandName": "品牌名称",
  "form.brand.contactName": "联系人姓名",
  "form.brand.contactPhone": "联系电话",
  "form.brand.adminPhone": "超管手机号",
  "form.brand.adminName": "超管身份名称",
  "form.brand.adminNameTooltip": '该管理员在品牌管理员身份下的名称，如"张总"',
  "validation.brand.nameRequired": "请输入品牌名称",
  "validation.brand.contactNameRequired": "请输入联系人姓名",
  "validation.brand.contactPhoneRequired": "请输入联系电话",
  "validation.brand.adminPhoneRequired": "请输入超管手机号",
  "placeholder.brand.name": "请输入品牌名称",
  "placeholder.brand.contactName": "请输入联系人姓名",
  "placeholder.brand.adminPhone": "请输入超管手机号",
  "placeholder.brand.adminName": "请输入超管身份名称（可选）",

  // ========== 门店管理 ==========
  "button.store.create": "创建门店",
  "button.store.subMerchantConfig": "商户配置",
  "error.store.loadListFailed": "加载门店列表失败",
  "error.store.deleteFailed": "删除门店失败",
  "error.store.operationFailed": "门店操作失败",
  "table.store.brandId": "品牌ID",
  "table.store.brandName": "品牌名称",
  "table.store.storeName": "门店名称",
  "table.store.province": "省份",
  "table.store.city": "城市",
  "table.store.district": "区县",
  "table.store.address": "详细地址",
  "table.store.contactPhone": "联系电话",
  "table.store.businessStatus": "营业状态",
  "modal.store.deleteTitle": "删除门店",
  "modal.store.deleteContent": "确定要删除该门店吗？",
  "modal.store.updateTitle": "修改门店",
  "modal.store.createTitle": "创建门店",
  "message.store.createSuccessTitle": "门店创建成功",
  "message.store.createSuccessDetail":
    "门店已创建成功，以下是超管账号信息，请妥善保管：",
  "message.store.passwordWarning": "注意：密码仅此一次显示，请务必记录保存！",
  "form.store.brandId": "所属品牌",
  "form.store.brandIdTooltip": "平台管理员必须指定品牌",
  "form.store.name": "门店名称",
  "form.store.region": "省市区",
  "form.store.address": "详细地址",
  "form.store.longitude": "经度",
  "form.store.latitude": "纬度",
  "form.store.contactPhone": "联系电话",
  "form.store.businessStatus": "营业状态",
  "form.store.adminPhone": "超管手机号",
  "form.store.adminPhoneTooltip": "如果该手机号不存在，系统会自动创建新账号",
  "form.store.adminName": "超管身份名称",
  "form.store.adminNameTooltip": '该管理员在门店管理员身份下的名称，如"张三"',
  "validation.store.brandIdRequired": "请选择品牌",
  "validation.store.nameRequired": "请输入门店名称",
  "validation.store.regionRequired": "请选择省市区",
  "validation.store.addressRequired": "请输入详细地址",
  "validation.store.longitudeRequired": "请输入经度",
  "validation.store.latitudeRequired": "请输入纬度",
  "validation.store.contactPhoneRequired": "请输入联系电话",
  "validation.store.businessStatusRequired": "请选择营业状态",
  "validation.store.adminPhoneRequired": "请输入超管手机号",
  "placeholder.store.name": "请输入门店名称",
  "placeholder.store.address": "请输入详细地址",
  "placeholder.store.longitude": "请输入经度",
  "placeholder.store.latitude": "请输入纬度",
  "placeholder.store.contactPhone": "请输入联系电话",
  "placeholder.store.adminPhone": "请输入超管手机号",
  "placeholder.store.adminName": "请输入超管身份名称（可选）",

  // ========== 菜单管理 ==========
  "button.menu.create": "创建菜单",
  "button.menu.bindPermission": "权限绑定",
  "error.menu.loadTreeFailed": "加载菜单树失败",
  "error.menu.loadListFailed": "加载菜单列表失败",
  "error.menu.deleteFailed": "删除菜单失败",
  "error.menu.operationFailed": "菜单操作失败",
  "error.menu.loadParentFailed": "加载父菜单失败",
  "menu.tree.all": "全部菜单",
  "menu.tree.title": "菜单目录",
  "table.menu.menuCode": "菜单编码",
  "table.menu.menuName": "菜单名称",
  "table.menu.path": "菜单路径",
  "table.menu.component": "组件路径",
  "table.menu.icon": "菜单图标",
  "table.menu.menuType": "菜单类型",
  "table.menu.sortOrder": "排序",
  "menu.type.pc": "PC端",
  "menu.type.miniProgram": "小程序",
  "menu.type.pos": "收银端",
  "modal.menu.deleteTitle": "删除菜单",
  "modal.menu.deleteContent": "确定要删除该菜单吗？",
  "modal.menu.updateTitle": "修改菜单",
  "modal.menu.createTitle": "创建菜单",
  "form.menu.menuCode": "菜单编码",
  "form.menu.menuName": "菜单名称",
  "form.menu.path": "路由路径",
  "form.menu.component": "组件路径",
  "form.menu.parentId": "父菜单",
  "form.menu.noParent": "无（顶级菜单）",
  "form.menu.icon": "菜单图标",
  "form.menu.menuType": "菜单类型",
  "form.menu.sortOrder": "排序",
  "form.menu.roleLevels": "适用角色层级",
  "form.menu.description": "菜单描述",
  "validation.menu.menuCodeRequired": "请输入菜单编码",
  "validation.menu.menuNameRequired": "请输入菜单名称",
  "validation.menu.parentIdRequired": "请选择父菜单",
  "validation.menu.menuTypeRequired": "请选择菜单类型",
  "validation.menu.roleLevelsRequired": "请选择适用角色层级",
  "validation.menu.sortOrderRequired": "请输入排序",
  "placeholder.menu.name": "请输入菜单名称",
  "placeholder.menu.menuName": "请输入菜单名称",
  "placeholder.menu.menuCode": "请输入菜单编码，如：brand_list",
  "placeholder.menu.path": "请输入路由路径，如：/brand/list",
  "placeholder.menu.component": "请输入组件路径，如：BrandList",
  "placeholder.menu.parentId": "请选择父菜单",
  "placeholder.menu.icon": "请输入菜单图标，如：list",
  "placeholder.menu.description": "请输入菜单描述",
  "placeholder.menu.sortOrder": "请输入排序号，数字越小越靠前",
  "message.menu.posOnlyForStore": "收银端菜单仅适用于门店管理员",
  "tooltip.menu.posRoleLevels": "POS菜单固定为门店层级",
  "tooltip.menu.posPath": "POS菜单路径可为空（仅用于权限控制）",

  // ========== 权限管理 ==========
  "error.permission.loadBoundFailed": "加载已绑定权限失败",
  "error.permission.loadListFailed": "加载权限列表失败",
  "error.permission.bindFailed": "权限绑定失败",
  "message.permission.bindSuccess": "权限绑定成功",
  "message.permission.bindFailed": "权限绑定失败",
  "table.permission.bindStatus": "绑定状态",
  "table.permission.permCode": "权限编码",
  "table.permission.permName": "权限名称",
  "table.permission.permType": "权限类型",
  "table.permission.apiPath": "API路径",
  "table.permission.httpMethod": "HTTP方法",
  "permission.type.menu": "菜单",
  "permission.type.button": "按钮",
  "permission.type.api": "接口",
  "modal.permission.title": "菜单权限绑定 (菜单ID: {menuId})",
  "modal.permission.alertTitle": "操作说明",
  "modal.permission.alertDescription":
    "选择需要绑定到此菜单的权限。提交后将覆盖此菜单原有的所有权限绑定。当前已选择 {selected} 个权限（初始绑定 {initial} 个）。",
  "placeholder.permission.search": "搜索权限编码、名称、API路径...",

  // ========== 角色管理 ==========
  "button.role.create": "创建角色",
  "error.role.getDetailsFailed": "获取角色详情失败",
  "table.role.roleName": "角色名称",
  "table.role.roleCode": "角色编码",
  "table.role.description": "角色描述",
  "table.role.roleLevel": "角色级别",
  "table.role.isPublic": "是否公共角色",
  "role.level.platform": "平台管理员",
  "role.level.brand": "品牌管理员",
  "role.level.store": "门店管理员",
  "role.level.fund": "资金账户",
  "role.systemDefault": "系统默认",
  "modal.role.deleteTitle": "删除角色",
  "modal.role.deleteConfirm":
    "确定要删除该角色吗？删除前请确保没有用户正在使用此角色。",
  "modal.role.editTitle": "修改角色",
  "modal.role.createTitle": "创建角色",
  "form.role.roleName": "角色名称",
  "form.role.roleCode": "角色编码",
  "form.role.roleLevel": "角色级别",
  "form.role.isPublic": "是否公共角色",
  "form.role.isPublic.tooltip":
    "公共角色可被所有品牌和门店使用，通常由平台管理员创建",
  "form.role.roleCode.tooltip":
    "系统预设字段，用于标识公共角色（如 PLATFORM_ADMIN、BRAND_ADMIN 等），选填",
  "form.role.description": "角色描述",
  "form.role.assignPermissions": "分配权限",
  "validation.role.nameRequired": "请输入角色名称",
  "validation.role.codeRequired": "请输入角色编码",
  "validation.role.roleLevelRequired": "请选择角色级别",
  "validation.role.permissionsRequired": "请选择至少一个权限",
  "validation.role.menuRequired": "请选择至少一个菜单权限",
  "placeholder.role.roleName": "请输入角色名称",
  "placeholder.role.roleCode": "请输入角色编码，如：BRAND_ADMIN",
  "placeholder.role.roleCode.optional": "选填，不填则为空",
  "placeholder.role.roleLevel": "请选择角色级别",
  "placeholder.role.description": "请输入角色描述",
  "placeholder.role.selectPermissions": "请选择权限",
  "message.role.posMenuInfo":
    "收银端菜单：用于收银端应用的权限控制，仅门店管理员可用",

  // ========== 公共角色管理 ==========
  "button.publicRole.create": "创建公共角色",
  "error.publicRole.getDetailsFailed": "获取公共角色详情失败",
  "modal.publicRole.deleteTitle": "删除公共角色",
  "modal.publicRole.deleteConfirm":
    "确定要删除该公共角色吗？删除前请确保没有用户正在使用此角色。",
  "modal.publicRole.editTitle": "修改公共角色",
  "modal.publicRole.createTitle": "创建公共角色",
  "message.publicRole.info":
    "公共角色可被所有品牌和门店使用，默认为平台级别角色，不需要选择品牌和门店。",
  "message.publicRole.selectRoleLevelFirst":
    "请先选择角色等级，系统将根据等级筛选可用菜单",
  "placeholder.publicRole.roleName": "请输入公共角色名称",
  "placeholder.publicRole.roleCode": "请输入角色编码，如：PUBLIC_CASHIER",
  "placeholder.publicRole.description": "请输入公共角色描述",
  "form.publicRole.roleLevel": "角色等级",
  "validation.publicRole.roleLevelRequired": "请选择角色等级",
  "table.publicRole.roleLevel": "角色等级",
  "roleLevel.platform": "平台角色",
  "roleLevel.brand": "品牌角色",
  "roleLevel.store": "门店角色",
  "roleLevel.fund": "资金账户",

  // ========== 管理员管理 ==========
  "button.admin.create": "创建管理员",
  "modal.admin.deleteTitle": "删除管理员",
  "modal.admin.deleteConfirm":
    "确定要删除该管理员吗？删除后该管理员将无法登录系统。",
  "modal.admin.editTitle": "修改管理员",
  "modal.admin.createTitle": "创建管理员",
  "message.admin.createSuccess": "管理员账号创建成功！",
  "message.admin.createSuccessExisting":
    "创建成功！该手机号已存在用户，使用原密码登录。",
  "form.admin.assignRoles": "分配角色",
  "form.admin.name": "姓名",
  "validation.admin.rolesRequired": "请选择至少一个角色",
  "placeholder.admin.selectRoles": "请选择角色（可多选）",
  "placeholder.admin.name": "请输入姓名",
  "table.admin.name": "姓名",
  "note.admin.phoneUnmodifiable":
    "注：手机号不允许修改。如需修改密码，请使用密码重置功能。",

  // ========== 球桌管理 ==========
  "button.table.create": "创建球桌",
  "error.table.loadListFailed": "加载球桌列表失败",
  "error.table.deleteFailed": "删除球桌失败",
  "error.table.operationFailed": "球桌操作失败",
  "table.table.brandName": "品牌名称",
  "table.table.storeName": "门店名称",
  "table.table.storeId": "门店ID",
  "table.table.tableNo": "球桌编号",
  "table.table.tableType": "球桌类型",
  "table.table.status": "状态",
  "table.table.hourlyRate": "时租价格",
  "table.table.deviceSn": "设备SN码",
  "table.status.idle": "空闲",
  "table.status.inUse": "使用中",
  "table.status.maintenance": "维修中",
  "table.status.disabled": "禁用",
  "table.tableType.snooker": "斯诺克",
  "table.tableType.chineseEight": "中式黑八",
  "table.tableType.nineBall": "九球",
  "modal.table.deleteTitle": "删除球桌",
  "modal.table.deleteContent": "确定要删除该球桌吗？",
  "modal.table.updateTitle": "修改球桌",
  "modal.table.createTitle": "创建球桌",
  "form.table.storeId": "所属门店",
  "form.table.tableNo": "球桌编号",
  "form.table.tableType": "球桌类型",
  "form.table.status": "状态",
  "form.table.hourlyRate": "时租价格",
  "form.table.hourlyRateTooltip": "单位：元/小时",
  "form.table.description": "球桌描述",
  "validation.table.storeIdRequired": "请选择所属门店",
  "validation.table.tableNoRequired": "请输入球桌编号",
  "validation.table.tableTypeRequired": "请选择球桌类型",
  "validation.table.statusRequired": "请选择状态",
  "placeholder.table.tableNo": "请输入球桌编号，如：A001",
  "placeholder.table.hourlyRate": "请输入时租价格",
  "placeholder.table.description": "请输入球桌描述",

  // ========== 设备管理 ==========
  "button.device.bind": "绑定设备",
  "button.device.unbind": "解绑门店",
  "error.device.loadListFailed": "加载设备列表失败",
  "error.device.bindFailed": "绑定设备失败",
  "error.device.unbindFailed": "解绑设备失败",
  "error.device.updateFailed": "更新设备信息失败",
  "message.device.bindSuccess": "设备绑定成功",
  "message.device.unbindSuccess": "设备解绑成功",
  "message.device.unbindFailed": "设备解绑失败",
  "message.device.updateSuccess": "设备信息更新成功",
  "message.device.noChanges": "没有修改任何信息",
  "table.device.deviceSn": "设备SN码",
  "table.device.name": "设备名称",
  "table.device.deviceType": "设备类型",
  "table.device.brandId": "所属品牌",
  "table.device.storeId": "所属门店",
  "table.device.bindStatus": "绑定状态",
  "table.device.onlineStatus": "在线状态",
  "table.device.firmwareVersion": "固件版本",
  "table.device.bindTime": "绑定时间",
  "table.device.lastOnlineTime": "最后在线时间",
  "deviceType.CAMERA": "摄像头",
  "deviceType.HOST": "计分条",
  "deviceType.SCORER": "计分器",
  "bindStatus.UNBOUND": "未绑定",
  "bindStatus.BOUND": "已绑定",
  "onlineStatus.OFFLINE": "离线",
  "onlineStatus.ONLINE": "在线",
  "modal.device.bindTitle": "绑定设备",
  "modal.device.editTitle": "编辑设备信息",
  "modal.device.unbindTitle": "解绑设备",
  "modal.device.unbindContent":
    "确定要解绑该设备吗？解绑后设备可以重新绑定到其他门店。",
  "form.device.deviceSn": "设备SN码",
  "form.device.name": "设备名称",
  "form.device.firmwareVersion": "固件版本",
  "form.device.brandId": "所属品牌",
  "form.device.storeId": "所属门店",
  "form.device.deviceSnRequired": "请输入设备SN码",
  "form.device.brandRequired": "请选择品牌",
  "form.device.storeRequired": "请选择门店",
  "form.device.deviceSnPlaceholder": "请输入设备SN码",
  "form.device.namePlaceholder": "请输入设备名称（可选）",
  "form.device.brandPlaceholder": "请选择品牌",
  "form.device.storePlaceholder": "请选择门店（需先选择品牌）",
  "form.device.storeAdminBindTip": "设备将自动绑定到您所属的品牌和门店",
  "validation.device.nameRequired": "请输入设备名称",

  // 设备绑定/解绑球桌
  "button.device.bindTable": "绑定球桌",
  "button.device.unbindTable": "解绑球桌",
  "message.device.bindTableSuccess": "设备绑定球桌成功",
  "message.device.bindTableFailed": "设备绑定球桌失败",
  "message.device.unbindTableSuccess": "设备解绑球桌成功",
  "message.device.unbindTableFailed": "设备解绑球桌失败",
  "message.device.notFound": "设备不存在",
  "error.device.bindTableFailed": "绑定球桌失败",
  "error.device.unbindTableFailed": "解绑球桌失败",
  "modal.device.bindTableTitle": "绑定球桌",
  "modal.device.unbindTableTitle": "解绑球桌",
  "modal.device.unbindTableContent":
    "确定要将设备从球桌解绑吗？解绑后设备仍绑定在门店，可重新绑定到其他球桌。",
  "table.device.tableNo": "球桌编号",
  "form.device.deviceInfo": "设备信息",
  "form.device.storeName": "所属门店",
  "form.device.tableId": "球桌",
  "form.device.tableRequired": "请选择球桌",
  "form.device.tablePlaceholder": "请选择球桌",

  // 设备上下线记录
  "button.device.onlineLogs": "上下线记录",
  "button.device.syncOnlineStatus": "同步状态",
  "modal.device.onlineLogsTitle": "设备上下线记录",
  "error.device.loadOnlineLogsFailed": "加载上下线记录失败",
  "message.device.syncingOnlineStatus": "正在同步设备在线状态...",
  "message.device.syncOnlineStatusSuccess": "设备在线状态同步成功",
  "error.device.syncOnlineStatusFailed": "同步设备在线状态失败",
  "table.deviceOnlineLog.eventType": "事件类型",
  "table.deviceOnlineLog.clientIp": "客户端IP",
  "table.deviceOnlineLog.eventTime": "事件时间",
  "eventType.ONLINE": "上线",
  "eventType.OFFLINE": "下线",

  // 设备绑定开放平台应用
  "button.device.bindOpenApp": "绑定应用",
  "button.device.rebindOpenApp": "更换应用",
  "button.device.unbindOpenApp": "解绑应用",
  "message.device.bindOpenAppSuccess": "设备绑定开放平台应用成功",
  "message.device.unbindOpenAppSuccess": "设备解绑开放平台应用成功",
  "error.device.bindOpenAppFailed": "绑定开放平台应用失败",
  "error.device.unbindOpenAppFailed": "解绑开放平台应用失败",
  "modal.device.bindOpenAppTitle": "绑定开放平台应用",
  "modal.device.unbindOpenAppTitle": "解绑开放平台应用",
  "modal.device.unbindOpenAppContent":
    "确定要解绑开放平台应用吗？解绑后设备数据将不再推送到第三方系统。",
  "table.device.openApp": "开放平台应用",
  "form.device.openAppId": "开放平台应用",
  "form.device.openAppRequired": "请选择开放平台应用",
  "form.device.openAppPlaceholder": "请选择开放平台应用",

  // 计分条管理
  "button.device.createScoreboard": "创建计分条",
  "button.device.deleteScoreboard": "删除计分条",
  "button.device.viewScoreboardCode": "查看开播码",
  "modal.device.createScoreboardTitle": "创建计分条",
  "modal.device.deleteScoreboardTitle": "删除计分条",
  "modal.device.deleteScoreboardContent":
    '确定要删除计分条"{name}"吗？删除后无法恢复。',
  "message.device.createScoreboardSuccess": "计分条创建成功",
  "message.device.deleteScoreboardSuccess": "计分条删除成功",
  "message.device.unbindTableBeforeDelete": "请先解绑球桌后再删除计分条",
  "error.device.createScoreboardFailed": "创建计分条失败",
  "error.device.deleteScoreboardFailed": "删除计分条失败",

  // ========== 开播码管理 ==========
  "pages.scoreboardCode.generateCode": "生成开播码",
  "pages.scoreboardCode.viewCode": "查看开播码",
  "pages.scoreboardCode.deleteCode": "删除开播码",
  "pages.scoreboardCode.copyUrl": "复制链接",
  "pages.scoreboardCode.copySuccess": "链接已复制到剪贴板",
  "pages.scoreboardCode.copyFailed": "复制失败",

  // 表格列
  "table.scoreboardCode.code": "开播码",
  "table.scoreboardCode.deviceSn": "设备SN码",
  "table.scoreboardCode.deviceName": "设备名称",
  "table.scoreboardCode.brandName": "所属品牌",
  "table.scoreboardCode.storeName": "所属门店",
  "table.scoreboardCode.url": "开播链接",
  "table.scoreboardCode.expireAt": "过期时间",
  "table.scoreboardCode.createdAt": "创建时间",
  "table.scoreboardCode.status": "状态",
  "table.scoreboardCode.status.enabled": "启用",
  "table.scoreboardCode.status.disabled": "禁用",
  "table.scoreboardCode.status.expired": "已过期",
  "table.scoreboardCode.status.valid": "有效",
  "table.scoreboardCode.displayConfig": "显示配置",
  "table.scoreboardCode.displayConfig.configured": "已配置",
  "table.scoreboardCode.displayConfig.empty": "未配置",
  "table.scoreboardCode.expireStatus": "过期状态",
  "table.scoreboardCode.expireStatus.valid": "有效",
  "table.scoreboardCode.expireStatus.expired": "已过期",

  // 按钮
  "button.scoreboardCode.generate": "生成开播码",
  "button.scoreboardCode.delete": "删除",
  "button.scoreboardCode.view": "查看",
  "button.scoreboardCode.copy": "复制链接",
  "button.scoreboardCode.enable": "启用",
  "button.scoreboardCode.disable": "禁用",

  // 消息提示
  "message.scoreboardCode.generateSuccess": "开播码生成成功",
  "message.scoreboardCode.deleteSuccess": "开播码删除成功",
  "message.scoreboardCode.updateStatusSuccess": "状态更新成功",
  "error.scoreboardCode.generateFailed": "生成开播码失败",
  "error.scoreboardCode.deleteFailed": "删除开播码失败",
  "error.scoreboardCode.loadListFailed": "加载开播码列表失败",
  "error.scoreboardCode.updateStatusFailed": "状态更新失败",

  // 表单
  "form.scoreboardCode.deviceId": "选择设备",
  "form.scoreboardCode.deviceIdRequired": "请选择设备",
  "form.scoreboardCode.deviceIdPlaceholder": "请选择设备",
  "form.scoreboardCode.expireHours": "有效期",
  "form.scoreboardCode.expireHoursRequired": "请输入有效期",
  "form.scoreboardCode.expireHoursPlaceholder": "默认24小时，最小1小时",
  "form.scoreboardCode.expireHoursMin": "有效期最小1小时",
  "form.scoreboardCode.displayConfig": "显示配置",
  "form.scoreboardCode.eventName": "赛事名称",
  "form.scoreboardCode.eventNamePlaceholder": "请输入赛事名称",
  "form.scoreboardCode.raceTo": "抢局数",
  "form.scoreboardCode.scoreBarSkin": "计分条皮肤",
  "form.scoreboardCode.scoreBarSkin.broadcast": "转播风格",
  "form.scoreboardCode.scoreBarSkin.classic": "经典风格",
  "form.scoreboardCode.players": "选手信息",
  "form.scoreboardCode.homePlayer": "选手 A",
  "form.scoreboardCode.awayPlayer": "选手 B",
  "form.scoreboardCode.playerName": "选手姓名",
  "form.scoreboardCode.nationality": "国籍",
  "form.scoreboardCode.nationalityPlaceholder": "请选择国籍",
  "form.scoreboardCode.homePlayerName": "选手 A - 选手姓名",
  "form.scoreboardCode.homePlayerNationality": "选手 A - 国籍",
  "form.scoreboardCode.homePlayerImageUrl": "选手A头像",
  "form.scoreboardCode.awayPlayerName": "选手 B - 选手姓名",
  "form.scoreboardCode.awayPlayerNationality": "选手 B - 国籍",
  "form.scoreboardCode.awayPlayerImageUrl": "选手B头像",
  "form.scoreboardCode.playerNamePlaceholder": "请输入选手姓名",

  // 弹窗
  "modal.scoreboardCode.generateTitle": "生成开播码",
  "modal.scoreboardCode.viewTitle": "开播码详情",
  "modal.scoreboardCode.deleteTitle": "删除开播码",
  "modal.scoreboardCode.deleteContent":
    "确定要删除该开播码吗？删除后该开播码将无法使用，但不影响已连接的计分台。",
  "modal.scoreboardCode.disableTitle": "禁用开播码",
  "modal.scoreboardCode.disableContent":
    "确定要禁用该开播码吗？禁用后计分台将无法通过该开播码连接。",
  "modal.scoreboardCode.deviceInfo": "设备信息",
  "modal.scoreboardCode.codeInfo": "开播码信息",
  "modal.scoreboardCode.code": "开播码",
  "modal.scoreboardCode.url": "开播链接",
  "modal.scoreboardCode.expireAt": "过期时间",
  "modal.scoreboardCode.shareTip":
    "您可以将以下链接分享给主播，主播打开链接即可连接计分台",

  // 筛选
  "filter.scoreboardCode.includeExpired": "包含已过期",

  // 切换身份相关
  "pages.switchAdmin.modalTitle": "切换管理员身份",
  "pages.switchAdmin.adminName": "身份名称",
  "pages.switchAdmin.adminTypeLabel": "身份类型",
  "pages.switchAdmin.currentRole": "当前身份",
  "pages.switchAdmin.selectRole": "选择要切换的身份",
  "pages.switchAdmin.switchSuccess": "切换身份成功",
  "pages.switchAdmin.switchFailed": "切换身份失败",
  "pages.switchAdmin.loading": "加载中...",
  "pages.switchAdmin.adminType.platform": "平台管理员",
  "pages.switchAdmin.adminType.brand": "品牌管理员",
  "pages.switchAdmin.adminType.store": "门店管理员",
  "pages.switchAdmin.adminType.fund": "资金账户",
  "pages.switchAdmin.brand": "品牌",
  "pages.switchAdmin.store": "门店",
  "pages.switchAdmin.noAdmins": "没有其他可切换的身份",

  // ========== 助教管理 ==========
  "error.coach.loadListFailed": "加载助教列表失败",
  "error.coach.deleteFailed": "删除助教失败",
  "error.coach.operationFailed": "助教操作失败",
  "table.coach.coachInfo": "助教信息",
  "table.coach.phone": "联系电话",
  "table.coach.gender": "性别",
  "table.coach.billingMode": "计费模式",
  "table.coach.serviceStatus": "服务状态",
  "table.coach.serviceStats": "服务统计",
  "gender.female": "女",
  "gender.male": "男",
  "billingMode.hourly": "按时计费",
  "billingMode.perTime": "按次计费",
  "time.minutes": "分钟",
  "time.perSession": "次",
  "time.hours": "小时",
  "serviceStatus.idle": "空闲",
  "serviceStatus.busy": "服务中",
  "stats.count": "次数",
  "stats.duration": "时长",
  "modal.coach.deleteTitle": "删除助教",
  "modal.coach.deleteBusyContent": "助教正在服务中，确定要删除吗？",
  "modal.coach.deleteContent": "确定要删除该助教吗？",
  "button.coach.create": "新建助教",
  "modal.coach.updateTitle": "修改助教",
  "modal.coach.createTitle": "新建助教",
  "form.coach.name": "助教姓名",
  "form.coach.phone": "联系电话",
  "form.coach.avatar": "助教头像",
  "form.coach.gender": "性别",
  "form.coach.billingMode": "计费模式",
  "form.coach.serviceFee": "服务费",
  "form.coach.serviceFeeTooltip": "金额以元为单位，支持小数点后两位",
  "form.coach.billingDuration": "计费时长",
  "form.coach.billingDurationTooltip": "按时计费时的时长单位",
  "form.coach.introduction": "个人简介",
  "validation.coach.nameRequired": "请输入助教姓名",
  "validation.coach.phoneRequired": "请输入联系电话",
  "validation.coach.billingModeRequired": "请选择计费模式",
  "validation.coach.serviceFeeRequired": "请输入服务费",
  "validation.coach.billingDurationRequired": "按时计费必须提供计费时长",
  "placeholder.coach.name": "请输入助教姓名",
  "placeholder.coach.billingMode": "请选择计费模式",
  "placeholder.coach.serviceFee": "请输入服务费",
  "placeholder.coach.billingDuration": "请输入计费时长",
  "placeholder.coach.introduction": "请输入个人简介",

  // ========== 商品分类 ==========
  "error.productCategory.loadListFailed": "加载商品分类列表失败",
  "error.productCategory.deleteFailed": "删除商品分类失败",
  "error.productCategory.operationFailed": "商品分类操作失败",
  "error.productCategory.loadFailed": "加载商品分类失败",
  "table.productCategory.name": "分类名称",
  "table.productCategory.icon": "分类图标",
  "modal.productCategory.deleteTitle": "删除商品分类",
  "modal.productCategory.deleteContent": "确定要删除该商品分类吗？",
  "button.productCategory.create": "新建分类",
  "modal.productCategory.updateTitle": "修改商品分类",
  "modal.productCategory.createTitle": "新建商品分类",
  "form.productCategory.name": "分类名称",
  "form.productCategory.icon": "分类图标",
  "validation.productCategory.nameRequired": "请输入分类名称",
  "placeholder.productCategory.name": "请输入分类名称",

  // ========== 商品管理 ==========
  "error.product.loadListFailed": "加载商品列表失败",
  "error.product.deleteFailed": "删除商品失败",
  "error.product.operationFailed": "商品操作失败",
  "table.product.categoryId": "商品分类",
  "table.product.name": "商品名称",
  "table.product.barcode": "商品条码",
  "table.product.image": "商品图片",
  "table.product.price": "价格（元）",
  "table.product.stock": "库存",
  "table.product.unit": "单位",
  "product.stock.unlimited": "不限",
  "product.status.onSale": "上架",
  "product.status.offSale": "下架",
  "modal.product.deleteTitle": "删除商品",
  "modal.product.deleteContent": "确定要删除该商品吗？",
  "button.product.create": "新建商品",
  "modal.product.updateTitle": "修改商品",
  "modal.product.createTitle": "新建商品",
  "form.product.categoryId": "商品分类",
  "form.product.name": "商品名称",
  "form.product.barcode": "商品条码",
  "form.product.price": "商品价格",
  "form.product.unit": "计量单位",
  "form.product.stock": "库存数量",
  "form.product.stockTooltip": "输入 -1 表示不限库存",
  "form.product.image": "商品图片",
  "form.product.description": "商品描述",
  "validation.product.nameRequired": "请输入商品名称",
  "validation.product.priceRequired": "请输入商品价格",
  "validation.product.stockRequired": "请输入库存数量",
  "placeholder.product.categoryId": "请选择商品分类",
  "placeholder.product.name": "请输入商品名称",
  "placeholder.product.barcode": "请输入商品条码",
  "placeholder.product.price": "请输入商品价格",
  "placeholder.product.unit": "请输入计量单位（如：张、个、份）",
  "placeholder.product.stock": "请输入库存数量",
  "placeholder.product.description": "请输入商品描述",
  "currency.yuan": "元",

  // ========== 通用 ==========
  "form.common.sortOrderTooltip": "数字越小越靠前",
  "placeholder.common.sortOrder": "请输入排序序号",

  // ========== 开放平台应用管理 ==========
  "button.openApp.create": "创建应用",
  "button.openApp.resetSecret": "重置密钥",
  "error.openApp.loadListFailed": "加载应用列表失败",
  "error.openApp.deleteFailed": "删除应用失败",
  "error.openApp.operationFailed": "应用操作失败",
  "error.openApp.resetSecretFailed": "重置密钥失败",
  "table.openApp.appName": "应用名称",
  "table.openApp.appId": "应用ID",
  "table.openApp.appType": "应用类型",
  "table.openApp.brandName": "品牌名称",
  "table.openApp.storeName": "门店名称",
  "table.openApp.rateLimit": "频率限制",
  "table.openApp.callbackUrl": "回调URL",
  "table.openApp.description": "应用描述",
  "appType.brand": "品牌应用",
  "appType.store": "门店应用",
  "modal.openApp.deleteTitle": "删除应用",
  "modal.openApp.deleteContent":
    "确定要删除该应用吗？删除后该应用的密钥将立即失效。",
  "modal.openApp.updateTitle": "修改应用",
  "modal.openApp.createTitle": "创建应用",
  "modal.openApp.resetSecretTitle": "重置应用密钥",
  "modal.openApp.resetSecretContent":
    "确定要重置该应用的密钥吗？重置后旧密钥将立即失效，使用该应用的第三方系统需要更新密钥配置。",
  "message.openApp.createSuccess": "应用创建成功！",
  "message.openApp.createSuccessDetail":
    "应用已创建成功，以下是应用密钥信息，请妥善保管：",
  "message.openApp.secretWarning":
    "注意：应用密钥仅此一次显示，请务必记录保存！",
  "message.openApp.resetSecretSuccess": "密钥重置成功！",
  "message.openApp.resetSecretDetail": "新密钥如下，请妥善保管：",
  "form.openApp.appName": "应用名称",
  "form.openApp.appType": "应用类型",
  "form.openApp.brandId": "所属品牌",
  "form.openApp.storeId": "所属门店",
  "form.openApp.rateLimit": "频率限制",
  "form.openApp.rateLimitTooltip": "每分钟最大调用次数",
  "form.openApp.callbackUrl": "回调URL",
  "form.openApp.description": "应用描述",
  "validation.openApp.appNameRequired": "请输入应用名称",
  "validation.openApp.appTypeRequired": "请选择应用类型",
  "validation.openApp.brandIdRequired": "请选择所属品牌",
  "validation.openApp.storeIdRequired": "门店应用必须选择门店",
  "placeholder.openApp.appName": "请输入应用名称",
  "placeholder.openApp.appType": "请选择应用类型",
  "placeholder.openApp.brandId": "请选择所属品牌",
  "placeholder.openApp.storeId": "请选择所属门店（门店应用必填）",
  "placeholder.openApp.rateLimit": "请输入频率限制",
  "placeholder.openApp.callbackUrl": "请输入回调URL",
  "placeholder.openApp.description": "请输入应用描述",
  "label.openApp.appId": "应用ID",
  "label.openApp.appSecret": "应用密钥",
  "unit.perMinute": "次/分钟",

  // ========== 订单管理 ==========
  "error.order.loadListFailed": "加载订单列表失败",
  "table.order.orderNo": "订单号",
  "table.order.orderType": "订单类型",
  "table.order.storeName": "门店名称",
  "table.order.storeId": "门店",
  "table.order.tableNo": "球桌编号",
  "table.order.totalAmount": "订单金额",
  "table.order.mergedAmount": "合单金额",
  "table.order.orderStatus": "订单状态",
  "table.order.payStatus": "支付状态",
  "table.order.operatorName": "操作员",
  "orderType.table": "开台订单",
  "orderType.retail": "零售订单",
  "orderType.coach": "助教订单",
  "orderStatus.pending": "待处理",
  "orderStatus.inProgress": "进行中",
  "orderStatus.completed": "已完成",
  "orderStatus.cancelled": "已取消",
  "orderStatus.refunded": "已退款",
  "payStatus.unpaid": "未支付",
  "payStatus.paying": "支付中",
  "payStatus.paid": "已支付",
  "payStatus.refunding": "退款中",
  "payStatus.refunded": "已退款",
  "payStatus.partialRefunded": "部分退款",
  "button.order.viewDetail": "查看",
  "modal.order.detailTitle": "订单详情",
  "detail.order.tableType": "球桌类型",
  "detail.order.billingMode": "计费模式",
  "detail.order.hourlyRate": "时租价格",
  "detail.order.startTime": "开始时间",
  "detail.order.endTime": "结束时间",
  "detail.order.actualDuration": "实际时长",
  "detail.order.tableAmount": "台费金额",
  "detail.order.discountAmount": "优惠金额",
  "detail.order.payAmount": "实付金额",
  "detail.order.paidAt": "支付时间",
  "detail.order.operatorName": "操作员",
  "detail.order.remark": "备注",
  "detail.order.subOrders": "子订单列表",
  // 商品信息
  "detail.order.itemList": "商品列表",
  "detail.order.productImage": "商品图片",
  "detail.order.productName": "商品名称",
  "detail.order.productPrice": "单价",
  "detail.order.quantity": "数量",
  "detail.order.subtotal": "小计",
  // 助教信息
  "detail.order.coachList": "助教列表",
  "detail.order.coachAvatar": "头像",
  "detail.order.coachName": "助教姓名",
  "detail.order.coachBillingMode": "计费模式",
  "detail.order.serviceFee": "服务费",
  "detail.order.coachServiceStatus": "服务状态",
  "detail.order.coachSubtotal": "小计",

  // ========== 通用：是/否 ==========
  "common.yes": "是",
  "common.no": "否",
  "common.configured": "已配置",
  "common.notConfigured": "未配置",

  // ========== 微信服务商配置 ==========
  "button.wechatSpConfig.create": "创建服务商配置",
  "modal.wechatSpConfig.deleteTitle": "删除服务商配置",
  "modal.wechatSpConfig.deleteContent":
    "确定要删除该服务商配置吗？删除后相关支付功能将无法使用。",
  "modal.wechatSpConfig.updateTitle": "修改服务商配置",
  "modal.wechatSpConfig.createTitle": "创建服务商配置",
  "table.wechatSpConfig.brandName": "品牌名称",
  "table.wechatSpConfig.brandId": "品牌",
  "table.wechatSpConfig.spMchid": "服务商商户号",
  "table.wechatSpConfig.spAppid": "服务商AppID",
  "table.wechatSpConfig.serialNo": "API证书序列号",
  "table.wechatSpConfig.hasApiKeyV2": "API v2密钥",
  "table.wechatSpConfig.hasCertContent": "API证书",
  "form.wechatSpConfig.brandId": "品牌",
  "form.wechatSpConfig.spMchid": "服务商商户号",
  "form.wechatSpConfig.spAppid": "服务商AppID",
  "form.wechatSpConfig.serialNo": "API证书序列号",
  "form.wechatSpConfig.apiKeyV2": "API v2密钥",
  "form.wechatSpConfig.apiKeyV2Tooltip": "32位API v2密钥，用于付款码支付",
  "form.wechatSpConfig.apiKeyV3": "API v3密钥",
  "form.wechatSpConfig.privateKey": "API私钥",
  "form.wechatSpConfig.privateKeyTooltip": "PEM格式的API私钥",
  "form.wechatSpConfig.certContent": "API证书内容",
  "form.wechatSpConfig.certContentTooltip": "API证书内容，用于API v2接口",
  "form.wechatSpConfig.configuredPlaceholder": "已配置，留空表示不修改",
  "validation.wechatSpConfig.brandIdRequired": "请选择品牌",
  "validation.wechatSpConfig.spMchidRequired": "请输入服务商商户号",
  "validation.wechatSpConfig.spAppidRequired": "请输入服务商AppID",
  "validation.wechatSpConfig.serialNoRequired": "请输入API证书序列号",
  "validation.wechatSpConfig.apiKeyV3Required": "请输入API v3密钥",
  "validation.wechatSpConfig.privateKeyRequired": "请输入API私钥",

  // ========== 支付宝服务商配置 ==========
  "button.alipaySpConfig.create": "创建支付宝服务商配置",
  "modal.alipaySpConfig.deleteTitle": "删除支付宝服务商配置",
  "modal.alipaySpConfig.deleteContent":
    "确定要删除该支付宝服务商配置吗？删除后相关支付功能将无法使用。",
  "modal.alipaySpConfig.updateTitle": "修改支付宝服务商配置",
  "modal.alipaySpConfig.createTitle": "创建支付宝服务商配置",
  "table.alipaySpConfig.brandId": "品牌",
  "table.alipaySpConfig.brandName": "品牌名称",
  "table.alipaySpConfig.appId": "应用APPID",
  "table.alipaySpConfig.configured": "配置状态",
  "form.alipaySpConfig.brandId": "品牌",
  "form.alipaySpConfig.appId": "应用APPID",
  "form.alipaySpConfig.serviceProviderId": "服务商PID",
  "form.alipaySpConfig.serviceProviderIdTooltip":
    "服务商PID用于返佣计算。如果您是支付宝服务商，填写此字段后可获得交易返佣。非服务商可留空。",
  "form.alipaySpConfig.privateKey": "应用私钥",
  "form.alipaySpConfig.privateKeyTooltip": "应用私钥，用于生成请求签名",
  "form.alipaySpConfig.appCertContent": "应用公钥证书内容",
  "form.alipaySpConfig.appCertContentTooltip":
    "应用公钥证书内容（.crt文件内容），完整的PEM格式",
  "form.alipaySpConfig.alipayCertContent": "支付宝公钥证书内容",
  "form.alipaySpConfig.alipayCertContentTooltip":
    "支付宝公钥证书内容（alipayCertPublicKey_RSA2.crt），完整的PEM格式",
  "form.alipaySpConfig.alipayRootCertContent": "支付宝根证书内容",
  "form.alipaySpConfig.alipayRootCertContentTooltip":
    "支付宝根证书内容（alipayRootCert.crt），完整的PEM格式",
  "form.alipaySpConfig.encryptKey": "内容加密密钥",
  "form.alipaySpConfig.encryptKeyTooltip":
    "AES加密密钥，用于加密敏感信息（可选）",
  "form.alipaySpConfig.configuredPlaceholder": "已配置，留空表示不修改",
  "validation.alipaySpConfig.brandIdRequired": "请选择品牌",
  "validation.alipaySpConfig.appIdRequired": "请输入应用APPID",
  "validation.alipaySpConfig.privateKeyRequired": "请输入应用私钥",
  "validation.alipaySpConfig.appCertContentRequired": "请输入应用公钥证书内容",
  "validation.alipaySpConfig.alipayCertContentRequired":
    "请输入支付宝公钥证书内容",
  "validation.alipaySpConfig.alipayRootCertContentRequired":
    "请输入支付宝根证书内容",

  // ========== 二级商户配置 ==========
  "button.subMerchant.create": "创建二级商户配置",
  "modal.subMerchant.deleteTitle": "删除二级商户配置",
  "modal.subMerchant.deleteContent":
    "确定要删除该二级商户配置吗？删除后该门店将无法使用支付功能。",
  "modal.subMerchant.updateTitle": "修改二级商户配置",
  "modal.subMerchant.createTitle": "创建二级商户配置",
  "modal.subMerchant.configTitle": "{storeName} - 商户配置",
  "table.subMerchant.brandName": "品牌名称",
  "table.subMerchant.brandId": "品牌",
  "table.subMerchant.storeName": "门店名称",
  "table.subMerchant.storeId": "门店",
  "table.subMerchant.wxSubMchid": "微信二级商户号",
  "table.subMerchant.wxSubAppid": "微信二级AppID",
  "table.subMerchant.wxFeeRate": "微信手续费率",
  "table.subMerchant.wxProfitSharingCap": "微信分账上限",
  "table.subMerchant.aliUserId": "支付宝用户ID",
  "table.subMerchant.aliAuthorized": "支付宝授权状态",
  "table.subMerchant.aliFeeRate": "支付宝手续费率",
  "table.subMerchant.aliProfitSharingCap": "支付宝分账上限",
  "form.subMerchant.brandId": "品牌",
  "form.subMerchant.storeId": "门店",
  "form.subMerchant.wechatConfig": "微信支付配置",
  "form.subMerchant.alipayConfig": "支付宝配置",
  "form.subMerchant.wxSubMchid": "二级商户号",
  "form.subMerchant.wxSubAppid": "二级商户AppID",
  "form.subMerchant.wxFeeRate": "手续费费率",
  "form.subMerchant.wxProfitSharingCap": "分账上限",
  "form.subMerchant.aliUserId": "支付宝用户ID",
  "form.subMerchant.aliUserIdTooltip":
    "授权商户的支付宝账号ID，格式如：2088123456789012",
  "form.subMerchant.aliAppAuthToken": "支付宝授权令牌",
  "form.subMerchant.aliAppAuthTokenTooltip":
    "商户授权后获得的app_auth_token，永久有效。格式如：202312BB1234567890abcdef...",
  "form.subMerchant.aliFeeRate": "手续费费率",
  "form.subMerchant.aliProfitSharingCap": "分账上限",
  "validation.subMerchant.brandIdRequired": "请选择品牌",
  "validation.subMerchant.storeIdRequired": "请选择门店",

  // ========== 退款管理 ==========
  "button.refund.create": "管理员主动退款",
  "button.refund.approve": "审批",
  "button.refund.sync": "同步状态",
  "button.refund.submit": "提交退款",
  "button.common.view": "查看",
  "error.refund.loadListFailed": "加载退款列表失败",
  "error.refund.syncFailed": "同步退款状态失败",
  "error.refund.operationFailed": "退款操作失败",
  "error.refund.searchFailed": "查询订单失败",
  "message.refund.createSuccess": "退款创建成功",
  "message.refund.approveSuccess": "审批成功",
  "message.refund.syncSuccess": "状态同步成功",
  "message.refund.searchSuccess": "订单查询成功",
  "message.refund.orderNotFound": "未找到该订单",
  "pages.refund.createTitle": "管理员主动退款",
  "pages.refund.searchOrder": "查询订单",
  "pages.refund.orderInfo": "订单信息",
  "pages.refund.refundInfo": "退款信息",
  "table.refund.refundNo": "退款单号",
  "table.refund.orderNo": "订单号",
  "table.refund.payChannel": "支付渠道",
  "table.refund.totalAmount": "订单金额",
  "table.refund.refundAmount": "退款金额",
  "table.refund.refundType": "退款类型",
  "table.refund.refundReason": "退款原因",
  "table.refund.applicantType": "申请人类型",
  "table.refund.applicantName": "申请人",
  "table.refund.approvalStatus": "审批状态",
  "table.refund.refundStatus": "退款状态",
  "modal.refund.createTitle": "管理员主动退款",
  "modal.refund.approveTitle": "退款审批",
  "form.refund.orderId": "订单ID",
  "form.refund.refundType": "退款类型",
  "form.refund.refundAmount": "退款金额",
  "form.refund.refundReason": "退款原因",
  "form.refund.approveAction": "审批操作",
  "form.refund.approveRemark": "审批备注",
  "placeholder.refund.searchValue": "请输入订单号或支付单号",
  "validation.refund.orderIdRequired": "请输入订单ID",
  "validation.refund.refundTypeRequired": "请选择退款类型",
  "validation.refund.refundAmountRequired": "请输入退款金额",
  "validation.refund.approveActionRequired": "请选择审批操作",
  "validation.refund.searchValueRequired": "请输入订单号或支付单号",
  "validation.refund.orderRequired": "请先查询订单",
  "validation.refund.refundReasonRequired": "请输入退款原因",
  "enum.refundType.full": "全额退款",
  "enum.refundType.partial": "部分退款",
  "enum.applicantType.user": "用户",
  "enum.applicantType.store": "门店管理员",
  "enum.applicantType.brand": "品牌管理员",
  "enum.applicantType.platform": "平台管理员",
  "enum.approvalStatus.pending": "待审批",
  "enum.approvalStatus.autoApproved": "自动通过",
  "enum.approvalStatus.approved": "已通过",
  "enum.approvalStatus.rejected": "已拒绝",
  "enum.refundStatus.pending": "待退款",
  "enum.refundStatus.processing": "退款中",
  "enum.refundStatus.success": "退款成功",
  "enum.refundStatus.failed": "退款失败",
  "enum.refundStatus.abnormal": "退款异常",
  "enum.approveAction.approve": "通过",
  "enum.approveAction.reject": "拒绝",
  "enum.payChannel.wechat": "微信支付",
  "enum.payChannel.alipay": "支付宝",

  // ========== 回调日志 ==========
  "error.callbackLog.loadListFailed": "加载回调日志列表失败",
  "pages.callbackLog.detailTitle": "回调详情",
  "table.callbackLog.appId": "应用",
  "table.callbackLog.matchNo": "比赛编号",
  "table.callbackLog.thirdPartyMatchId": "第三方比赛ID",
  "table.callbackLog.eventType": "事件类型",
  "table.callbackLog.status": "回调状态",
  "table.callbackLog.responseStatus": "响应状态",
  "table.callbackLog.retryCount": "重试次数",
  "table.callbackLog.costTime": "耗时",
  "table.callbackLog.timestamp": "回调时间",
  "table.callbackLog.startTime": "开始时间",
  "table.callbackLog.endTime": "结束时间",
  "table.callbackLog.requestBody": "请求体",
  "table.callbackLog.responseBody": "响应体",
  "table.callbackLog.errorMessage": "错误信息",
  "button.common.detail": "详情",
  "eventType.matchStart": "比赛开始",
  "eventType.frameScore": "局得分",
  "eventType.frameEnd": "局结束",
  "eventType.matchEnd": "比赛结束",
  "status.success": "成功",
  "status.failure": "失败",

  // ========== API 调用日志 ==========
  "error.apiLog.loadListFailed": "加载API日志列表失败",
  "pages.apiLog.detailTitle": "API调用详情",
  "table.apiLog.appId": "应用",
  "table.apiLog.apiPath": "API路径",
  "table.apiLog.httpMethod": "HTTP方法",
  "table.apiLog.responseCode": "响应状态码",
  "table.apiLog.requestIp": "请求IP",
  "table.apiLog.costTime": "耗时",
  "table.apiLog.timestamp": "调用时间",
  "table.apiLog.startTime": "开始时间",
  "table.apiLog.endTime": "结束时间",
  "table.apiLog.requestParams": "请求参数",
  "table.apiLog.userAgent": "User-Agent",
  "table.apiLog.errorMessage": "错误信息",

  // ========== 订单营收统计 ==========
  "pages.statistics.orderRevenue.dateRange": "统计时间",
  "pages.statistics.orderRevenue.brand": "品牌",
  "pages.statistics.orderRevenue.store": "门店",
  "pages.statistics.orderRevenue.totalAmount": "交易金额",
  "pages.statistics.orderRevenue.paidAmount": "实付金额",
  "pages.statistics.orderRevenue.income": "净收入",
  "pages.statistics.orderRevenue.refundedAmount": "退款金额",
  "pages.statistics.orderRevenue.totalOrderCount": "订单笔数",
  "pages.statistics.orderRevenue.averageOrderAmount": "平均客单价",
  "pages.statistics.orderRevenue.ordersByType": "订单类型分布",
  "pages.statistics.orderRevenue.orderType.table": "开台订单",
  "pages.statistics.orderRevenue.orderType.retail": "零售订单",
  "pages.statistics.orderRevenue.orderType.coach": "助教订单",
  "pages.statistics.orderRevenue.chart.title": "经营分析",
  "pages.statistics.orderRevenue.chart.amount": "交易金额",
  "pages.statistics.orderRevenue.chart.orderCount": "订单笔数",
  "pages.statistics.orderRevenue.chart.unit.orders": "笔",
};
